import { takeLatest, takeEvery, all } from 'redux-saga/effects';

import { handleRequest } from '@sagas/request';
import { reducedRatesRequest, reducedRatesCreate } from '@store/reducedRates';

export default all([
  takeLatest(reducedRatesRequest.type, handleRequest),
  takeEvery(reducedRatesCreate.type, handleRequest),
]);
